import { createSelector } from 'reselect';
import { AppState } from '../..';
import getBoundingAreasByLocation from '../../../geofencing';

const STATE_ACRONYM: { [key: string]: string } = {
  NEWSOUTHWALES: 'NSW',
  NORTHERNTERRITORY: 'NT',
  QUEENSLAND: 'QLD',
  SOUTHAUSTRALIA: 'SA',
  TASMANIA: 'TAS',
  VICTORIA: 'VIC',
  WESTERNAUSTRALIA: 'WA',
  UNITEDSTATES: 'USA',
  HAWAII: 'USA',
  ALASKA: 'USA',
};

export const getWaterBodyDefinitions = createSelector(
  (state: AppState) => state.prepare.waterBodyDefinitions || [],
  (state: AppState) =>
    state.appControls.currentMapParams.viewPortDetails.center,
  (definitions, { lat: latitude, lon: longitude }) =>
    [...definitions]
      .sort((a, b) => (a.name > b.name ? 1 : -1))
      .sort((a) => {
        const boundingAreas = getBoundingAreasByLocation({
          longitude,
          latitude,
        });
        const states = boundingAreas.map((area) => STATE_ACRONYM[area]);

        if (states.includes(a.areaWaterBodyKey.split('_')[0])) {
          return -1;
        }

        return 0;
      }),
);
